import { DefinitionLevels, SettingValues } from '@linearb/linjs-common';
import useSettingsService from 'components/hooks/useSettingsService';
import useToast from 'components/hooks/useToast';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectedTeamSelector } from 'state/selectors/ui-state';

export const useSaveIncidentsSettings = ({
  cfrConfiguration,
  mttrConfiguration,
  isOrgSettings,
  value
} = {}) => {
  const toast = useToast();
  const { updateSetting, getSettingOrDefinitionValue } = useSettingsService();
  const selectedTeam = useSelector(selectedTeamSelector);
  const teamId = selectedTeam?.id;
  const isTeamSetting = !isOrgSettings;
  const definitionLevel = isTeamSetting
    ? DefinitionLevels.TEAM
    : DefinitionLevels.ORGANIZATION;
  const entityId = selectedTeam?.id;
  const settingName = SettingValues.INCIDENTS_STRATEGY;
  const incidentsStrategy = getSettingOrDefinitionValue({
    name: settingName,
    definitionLevel,
    ...(!isOrgSettings && { teamId })
  });

  const [isSaveEnabled, setIsSaveEnabled] = useState(false);
  const [isUsingParentConfig, setIsUsingParentConfig] = useState(
    !!incidentsStrategy?.use_parent
  );

  useEffect(() => {
    const isUsingParentConfig = !!incidentsStrategy?.use_parent;

    setIsUsingParentConfig(isUsingParentConfig);
  }, [incidentsStrategy]);

  const saveSettings = async () => {
    const incidentsStrategyPayload = {
      ...value,
      use_parent: false
    };
    const updateSettingsPromises = [
      updateSetting(
        settingName,
        incidentsStrategyPayload,
        definitionLevel,
        entityId,
        true
      ),
      updateSetting(
        SettingValues.CFR_CONFIG,
        cfrConfiguration,
        definitionLevel,
        entityId,
        false
      ),
      updateSetting(
        SettingValues.MTTR_CONFIG,
        mttrConfiguration,
        definitionLevel,
        entityId,
        false
      )
    ];
    await Promise.all(updateSettingsPromises);
    setIsSaveEnabled(false);
    setIsUsingParentConfig(false);
  };

  const onSaveParentConfig = async () => {
    const payload = {
      ...value,
      use_parent: true
    };
    try {
      await updateSetting(
        SettingValues.INCIDENTS_STRATEGY,
        payload,
        DefinitionLevels.TEAM,
        entityId
      );
      setIsSaveEnabled(false);
      setIsUsingParentConfig(true);
      toast({ message: 'Setting updated successfully' });
    } catch (e) {
      toast({
        variant: 'error',
        message: 'Failed to update setting'
      });
    }
  };

  return {
    saveSettings,
    isSaveEnabled,
    setIsSaveEnabled,
    isUsingParentConfig,
    onSaveParentConfig
  };
};
